
import { defineComponent } from 'vue'
import hemisphereService from '@/services/hemisphere.service'
import metaInfoService from '@/services/meta-info.service'
import MapboxService from '@/services/mapbox.service'
const mapboxService = new MapboxService()
import { FileUploadUploadEvent } from 'primevue/fileupload'
import BuildingImage from '@/components/BuildingImage.vue'
import { useCurrentBuildingId } from '@/composables/currentBuildingId'
import { CustomData } from '@/services/model/customData'

export default defineComponent({
  setup() {
    return {
      getCurrentBuildingId: useCurrentBuildingId()
    }
  },
  data() {
    return {
      showUpdatePicture: false,
      imageUrltag: undefined as undefined | number,
      buildingInfo: {} as any,
      metaInfo: {} as any,
      nickname: '',
      updating: false,
      syndicInfo: {
        syndicName: '',
        syndicMail: '',
        syndicPhone: '',
        isSyndicMember: false,
        lastGADate: ''
      }
    }
  },
  methods: {
    editImage() {
      this.showUpdatePicture = true
    },
    async saveCustomData() {
      this.updating = true
      try {
        let data = [] as CustomData[]
        if (this.customData.syndicName != this.syndicInfo.syndicName) {
          data.push({
            key: 'syndic_name',
            value: this.syndicInfo.syndicName,
            type: 'string',
            tags: ['#description'],
            desc: 'The name of the managing office'
          })
        }
        if (this.customData.syndicMail != this.syndicInfo.syndicMail) {
          data.push({
            key: 'syndic_mail',
            value: this.syndicInfo.syndicMail,
            type: 'string',
            tags: ['#description'],
            desc: 'The mail of the managing office'
          })
        }
        if (this.customData.syndicPhone != this.syndicInfo.syndicPhone) {
          data.push({
            key: 'syndic_phone',
            value: this.syndicInfo.syndicPhone,
            type: 'string',
            tags: ['#description'],
            desc: 'The phone number of the managing office'
          })
        }
        if (this.customData.lastGADate != this.syndicInfo.lastGADate) {
          data.push({
            key: 'last_ga_date',
            value: this.syndicInfo.lastGADate,
            type: 'string',
            tags: ['#description'],
            desc: 'The last date of the general assembly'
          })
        }
        if (this.customData.isSyndicMember != this.syndicInfo.isSyndicMember) {
          data.push({
            key: 'is_syndic_member',
            value: this.syndicInfo.isSyndicMember ? 'true' : 'false',
            type: 'boolean',
            tags: ['#description'],
            desc: 'Is the user member of the condominium council'
          })
        }
        const resp = await metaInfoService.post(this.buildingInfo.id, data)
        this.metaInfo = resp.data
      } catch (error) {
        console.log({ error })
      }
      this.updating = false
    },
    async saveBuilding() {
      this.updating = true
      try {
        const resp = await hemisphereService.updateBuilding(
          {
            nickname: this.nickname
          },
          this.buildingInfo.id
        )
        this.buildingInfo = resp.data
      } catch (error) {
        console.log({ error })
      }
      this.updating = false
    },
    async updateBuildingPicture(event: FileUploadUploadEvent) {
      let file = event.files
      if (Array.isArray(file)) {
        file = file[0]
      }
      try {
        const resp = await hemisphereService.setBuildingPicture(this.buildingInfo.id, file)
        if (resp.data.image_url == this.buildingInfo.image_url) {
          this.imageUrltag = Date.now()
        }
      } catch (error) {
        console.log(error)
      }

      this.showUpdatePicture = false
    },
    async refreshBuildingInfo(buildingId: string) {
      const resp = await hemisphereService.getBuilding(buildingId)
      console.log('get image=', resp.data.image_url)
      const metaResp = await metaInfoService.get(buildingId)
      this.setBuildingInfo(resp.data, metaResp.data)
    },
    setBuildingInfo(buildingInfo: any, metaInfo: any) {
      this.buildingInfo = buildingInfo
      this.nickname = this.buildingInfo.nickname
      this.metaInfo = metaInfo
      this.syndicInfo = { ...this.customData }
    }
  },
  computed: {
    customData(): any {
      let data = {
        syndicName: '',
        syndicMail: '',
        syndicPhone: '',
        isSyndicMember: false,
        lastGADate: ''
      }
      if (this.metaInfo.customData) {
        const syndicName = this.metaInfo.customData.find((d: any) => d.key === 'syndic_name').value
        const syndicMail = this.metaInfo.customData.find((d: any) => d.key === 'syndic_mail')?.value
        const syndicPhone = this.metaInfo.customData.find((d: any) => d.key === 'syndic_phone')?.value
        const isSyndicMember = JSON.parse(this.metaInfo.customData.find((d: any) => d.key === 'is_syndic_member')?.value)
        const lastGADate = this.metaInfo.customData.find((d: any) => d.key === 'last_ga_date')?.value
        if (syndicName) data.syndicName = syndicName
        if (syndicMail) data.syndicMail = syndicMail
        if (syndicPhone) data.syndicPhone = syndicPhone
        if (isSyndicMember) data.isSyndicMember = isSyndicMember
        if (lastGADate) data.lastGADate = lastGADate
      }
      return data
    },
    identityModified(): boolean {
      const previous = this.buildingInfo.nickname || ''
      const current = this.nickname || ''
      return previous != current
    },
    syndicInfoModified(): boolean {
      return JSON.stringify(this.customData) !== JSON.stringify(this.syndicInfo)
    },
    buildingIdentityTag(): any {
      if (this.identityModified) {
        return {
          text: 'MODIFIÉ',
          class: 'bg-primary-blue'
        }
      }
      let count = 0
      if (this.buildingInfo.project) count += 1
      if (this.buildingInfo.label) count += 1
      if (this.buildingInfo.nickname) count += 1
      if (count >= 2) {
        return {
          text: '3/3',
          class: 'bg-green'
        }
      }
      return {
        text: `${count}/3`,
        class: 'bg-red'
      }
    },
    buildingSyndicInfoTag(): any {
      if (this.syndicInfoModified) {
        return {
          text: 'MODIFIÉ',
          class: 'bg-primary-blue'
        }
      }
      let count = 0
      if (this.customData.syndicName) count += 1
      if (this.customData.syndicMail) count += 1
      if (this.customData.syndicPhone) count += 1
      if (this.customData.isSyndicMember != null) count += 1
      if (this.customData.lastGADate) count += 1
      if (count == 5) {
        return {
          text: '5/5',
          class: 'bg-green'
        }
      }
      return {
        text: `${count}/5`,
        class: 'bg-red'
      }
    },
    locationImage(): string | undefined {
      const lat = this.buildingInfo.address?.latitude
      const lon = this.buildingInfo.address?.longitude
      if (!lat || !lon) {
        return undefined
      }
      return mapboxService.getStaticImageURL(lon, lat, 15, 200, 128)
    },
    imageUrl(): string {
      let res = this.buildingInfo.image_url
      if (typeof this.imageUrltag !== 'undefined') {
        res += '?' + this.imageUrltag
      }
      return res
    }
  },
  async mounted() {
    const buildingId = await this.getCurrentBuildingId()
    if (buildingId) await this.refreshBuildingInfo(buildingId)
  },
  components: {
    BuildingImage
  }
})
